import { Validators } from '@angular/forms';
import { ButtonType, CrudFormConfig, CrudFormTextBoxItem, CrudViewFormItemType, FormLayout, TextBoxType } from '@rappider/rappider-components/utils';

export const SALESFORCE_CONNECT_EDIT_FORM_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'Username',
      fieldName: 'username',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Password',
      fieldName: 'password',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      textType: TextBoxType.Password,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'Security Token',
      fieldName: 'token',
      type: CrudViewFormItemType.TextBox,
      showRequiredSign: true,
      textType: TextBoxType.Password,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    },
  },
  submitButton: {
    type: ButtonType.Primary
  },
  formLayout: FormLayout.Vertical
};

